import { useId } from "react";

type RightLaurelLeafDesktopProps = {
	width?: string;
	height?: string;
	className?: string;
};

export function RightLaurelLeafDesktop({
	width = "8px",
	height = "16px",
	className,
}: RightLaurelLeafDesktopProps) {
	const id = useId().replace(/:/g, "_");
	const clipPathId = `clip0_${id}`;
	const gradientId = `paint0_linear_${id}`;
	const usesCssVarSize = width.includes("var(") || height.includes("var(");
	const svgStyle = usesCssVarSize ? { width, height } : undefined;

	return (
		<svg
			width={usesCssVarSize ? undefined : width}
			height={usesCssVarSize ? undefined : height}
			viewBox="0 0 8 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			style={svgStyle}
			aria-hidden="true"
		>
			<g clipPath={`url(#${clipPathId})`}>
				<path
					d="M7.4751 6.37149C7.41421 6.37207 7.33967 6.42037 7.28455 6.45509C6.29136 7.07872 5.57456 8.21144 5.38716 9.45408C5.41682 8.95049 5.44648 8.4469 5.47587 7.9433C5.48716 7.7495 5.5058 7.47153 5.57981 7.3081C5.65383 7.14467 5.80685 7.00727 5.94202 6.83777C6.78691 5.77823 6.92785 4.10749 6.26774 2.89696C6.25173 2.86746 6.20186 2.80874 6.1764 2.78878C6.03677 2.6806 5.93257 2.86514 5.85567 3.0008C5.31209 3.9591 5.07561 5.12451 5.19661 6.24682C4.97692 5.72443 4.75198 5.17108 4.79923 4.59749C4.82128 4.3308 4.90212 4.07394 4.95041 3.80811C5.18506 2.52353 4.54148 1.10416 3.45959 0.552549C3.44699 0.546185 3.43308 0.542714 3.41917 0.542135C3.26825 0.537507 3.2525 0.657548 3.24751 0.759655C3.20184 1.69279 3.40368 2.63894 3.82206 3.45204C3.45985 3.05431 3.31917 2.87989 3.05748 2.39568C2.79607 1.91147 2.64646 1.20655 2.13911 0.797548C1.30262 0.123584 0.285288 0.123873 0.207859 0.236104C0.0787245 0.423541 0.548019 1.59184 1.46587 2.23717C1.84462 2.50357 2.40604 2.70952 2.80446 2.93861C3.20289 3.1677 3.58793 3.48212 3.76799 3.93567C3.07428 3.42948 2.20472 3.2244 1.38372 3.37336C1.32676 3.38378 1.26167 3.40084 1.27637 3.51654C1.27716 3.52233 1.27899 3.52811 1.28162 3.53303C1.82441 4.54311 2.78977 5.2622 3.84148 5.44443C4.0924 5.48782 4.3693 5.51298 4.55067 5.7091C4.68112 5.84996 4.73545 6.0536 4.78059 6.24856C4.93073 6.89736 5.03283 7.55946 5.08558 8.22648C4.90947 7.2138 4.17954 6.34343 3.27743 6.07009C3.22914 6.05562 3.17192 6.02757 3.13176 6.09265C3.11129 6.12533 3.121 6.28298 3.12284 6.3229C3.17323 7.47644 3.63308 8.4978 4.39949 9.28516C4.57613 9.46652 4.77981 9.65425 4.81839 9.91689C4.8407 10.0693 4.80212 10.2241 4.75933 10.3713C4.53308 11.1471 4.17219 11.8746 3.70211 12.5037C4.16825 11.5341 4.12731 10.2906 3.59213 9.36412C3.56431 9.31611 3.51759 9.23512 3.46982 9.21342C3.37586 9.17061 3.29213 9.30164 3.24043 9.38408C2.64462 10.336 2.43202 11.5688 2.66982 12.6952C2.72205 12.9428 2.79449 13.2046 2.71864 13.4446C2.65381 13.6491 2.49291 13.7961 2.33307 13.9225C1.7517 14.3821 1.10629 14.6853 0.417572 14.8863C0.281088 14.9262 0.264815 14.9253 0.257728 14.9447C0.213371 15.0671 0.428858 15.3902 0.464816 15.3887C0.552481 15.3855 1.08897 15.2117 1.30787 15.1654C1.62152 15.0989 1.93176 15.2641 2.23464 15.3757C3.43675 15.8191 4.79162 15.4642 5.60186 14.3636C5.60343 14.3616 5.60448 14.359 5.60527 14.3567C5.6533 14.1987 5.51446 14.1669 5.41656 14.1331C4.47114 13.8053 3.41444 13.8846 2.51785 14.3506C2.95617 14.0885 3.25014 13.5794 3.70893 13.3642C4.02731 13.215 4.38558 13.226 4.72862 13.1774C5.87588 13.0142 6.90974 12.1025 7.30187 10.9024C7.31316 10.8677 7.34019 10.7309 7.33966 10.6941C7.3373 10.4529 7.03993 10.5194 6.84281 10.5602C5.8827 10.7595 4.99424 11.3533 4.3903 12.1994C4.57665 11.793 4.76275 11.3863 4.9491 10.9799C5.0197 10.8254 5.08926 10.6071 5.2449 10.4746C5.43414 10.3135 5.56249 10.3123 5.75383 10.2192C6.99557 9.61491 7.7856 8.04107 7.58166 6.56008C7.57641 6.52277 7.552 6.37033 7.47431 6.3712L7.4751 6.37149Z"
					fill={`url(#${gradientId})`}
				/>
				<path
					d="M0.793945 0.717529C1.14618 0.929264 1.48975 1.16067 1.80183 1.44067C2.11364 1.7224 2.35931 2.075 2.64934 2.38103C2.61128 2.34517 2.57322 2.3093 2.53595 2.27227C2.27584 2.01397 2.0517 1.7143 1.7782 1.4722C1.47059 1.19046 1.12964 0.956743 0.794208 0.717529H0.793945Z"
					fill="#E55C3C"
				/>
				<path
					d="M3.5835 0.97583C4.16801 1.73426 4.49636 2.72351 4.50607 3.71768C4.5066 3.8597 4.5024 4.00144 4.49033 4.1423C4.494 4.00086 4.49453 3.85912 4.48796 3.71826C4.45148 2.72929 4.12759 1.76231 3.58376 0.97583H3.5835Z"
					fill="#E55C3C"
				/>
			</g>
			<defs>
				<linearGradient
					id={gradientId}
					x1="3.44463"
					y1="7.87099"
					x2="7.07483"
					y2="7.87099"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F87D55" />
					<stop offset="0.72" stopColor="#FA8861" />
				</linearGradient>
				<clipPath id={clipPathId}>
					<rect width="8" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
